export function getTeamMemberFromTag(tags, tagName) {
  if (!tags || !tagName) return '';

  const foundTags = tags.filter(({ name }) => name.includes(tagName));
  return foundTags && foundTags.length > 0
    ? foundTags.map(({ name }) => name.split(': ')[1]).join(', ')
    : '';
}
